import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, BookOpen } from 'lucide-react';
export const Modules = () => {
  const modules = [{
    title: 'CAPÍTULO 1 — FUNDAMENTOS DEL RENDIMIENTO EN RUGBY MODERNO',
    items: ['Cómo entrenan los jugadores que marcan diferencias', 'Qué exige el rugby actual', 'Los errores que frenan el progreso de la mayoría de los jugadores', 'Cómo desarrollar capacidades transferibles al partido', 'Inteligencia táctica aplicada al rugby', 'Toma de decisiones bajo presión', 'Lectura del juego', 'Entrenamiento invisible', 'Recuperación y adaptación', 'Construcción de hábitos de alto rendimiento', 'Mentalidad competitiva', 'Organización del entrenamiento semanal', 'Cómo evaluar tu progreso real']
  }, {
    title: 'CAPÍTULO 2 — ATAQUE Y DEFINICIÓN',
    subtitle: 'Especial para Wings y Fullbacks',
    items: ['Cómo generar ventaja en velocidad', 'Aceleración aplicada al rugby', 'Cambios de dirección', 'Timing de carrera', 'Lectura de espacios', 'Finalización de jugadas', 'Recepción aérea', 'Kick Chase', 'Cómo ganar duelos 1 vs 1', 'Apoyos ofensivos', 'Juego sin pelota', 'Toma de decisiones en velocidad']
  }, {
    title: 'CAPÍTULO 3 — CONTROL DEL PARTIDO',
    subtitle: 'Especial para Medioscrum y Apertura',
    items: ['Cómo controlar el ritmo del juego', 'Distribución eficiente', 'Lectura táctica avanzada', 'Visión periférica', 'Gestión territorial', 'Juego con el pie', 'Creación de ventajas', 'Comunicación dentro del equipo', 'Organización ofensiva', 'Toma de decisiones rápidas', 'Liderazgo dentro del campo', 'Desarrollo del IQ rugbístico']
  }, {
    title: 'CAPÍTULO 4 — POTENCIA Y DOMINIO DEL CONTACTO',
    subtitle: 'Especial para Centros y Segundas Líneas',
    items: ['Potencia aplicada al rugby', 'Dominio físico en el contacto', 'Cómo ganar metros después del impacto', 'Offloads efectivos', 'Tackle dominante', 'Aceleración en espacios reducidos', 'Posicionamiento defensivo', 'Contacto seguro y eficiente', 'Resistencia específica', 'Entrenamiento explosivo', 'Agresividad competitiva', 'Dominio físico del partido']
  }, {
    title: 'CAPÍTULO 5 — SCRUM, RUCK Y MAUL',
    subtitle: 'Especial para Pilares y Hookers',
    items: ['Técnica de scrum', 'Generación de fuerza aplicada', 'Posicionamiento corporal', 'Estabilidad y potencia', 'Dominio del contacto corto', 'Ruck eficiente', 'Maul ofensivo y defensivo', 'Trabajo específico de forwards', 'Fuerza funcional', 'Core y estabilidad', 'Movilidad específica', 'Prevención de lesiones para forwards']
  }, {
    title: 'CAPÍTULO 6 — PREPARACIÓN FÍSICA PARA RUGBY',
    items: ['Fuerza aplicada al rugby', 'Potencia explosiva', 'Sprint y aceleración', 'Resistencia específica', 'Sistemas energéticos', 'Pliometría', 'Entrenamiento de velocidad', 'Movilidad deportiva', 'Core y estabilidad', 'Recuperación deportiva', 'Periodización', 'Cómo combinar gimnasio y rugby']
  }, {
    title: 'CAPÍTULO 7 — MENTALIDAD Y RENDIMIENTO COMPETITIVO',
    items: ['Psicología deportiva aplicada', 'Cómo jugar sin miedo al error', 'Confianza competitiva', 'Control emocional', 'Concentración en partido', 'Manejo de presión', 'Rutinas pre partido', 'Liderazgo deportivo', 'Visualización', 'Consistencia competitiva', 'Gestión de frustración', 'Mentalidad de alto rendimiento']
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full py-24 px-4 bg-zinc-950" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-bold uppercase tracking-tight mb-6 font-oswald text-white" data-id="element-151">
            ¿QUÉ INCLUYE EL <span className="text-lime-400" data-id="element-152">SISTEMA</span>?
          </h2>
          <div className="w-24 h-1 bg-lime-400 mx-auto mb-8" data-id="element-153"></div>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto" data-id="element-154">
            7 Capítulos diseñados estratégicamente para cubrir absolutamente
            todas las áreas del rendimiento en el rugby.
          </p>
        </div>

        <div className="space-y-4" data-id="element-155">
          {modules.map((mod, idx) => <div key={idx} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === idx ? 'border-lime-500/50 bg-zinc-900/50' : 'border-zinc-800 bg-zinc-900/20 hover:border-zinc-700'}`} data-id="element-156">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-157">
                <div className="flex items-start gap-4" data-id="element-158">
                  <BookOpen className={`w-6 h-6 shrink-0 mt-1 ${openIndex === idx ? 'text-lime-400' : 'text-zinc-500'}`} data-id="element-159" />
                  <div data-id="element-160">
                    <h3 className={`font-oswald text-xl tracking-wide uppercase ${openIndex === idx ? 'text-white' : 'text-zinc-300'}`} data-id="element-161">
                      {mod.title}
                    </h3>
                    {mod.subtitle && <p className="text-lime-400/80 text-sm font-medium mt-1" data-id="element-162">
                        {mod.subtitle}
                      </p>}
                  </div>
                </div>
                <ChevronDown className={`w-6 h-6 shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180 text-lime-400' : 'text-zinc-500'}`} data-id="element-163" />
              </button>

              <AnimatePresence data-id="element-164">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-165">
                    <div className="px-6 pb-6 pt-2 pl-16" data-id="element-166">
                      <ul className="grid md:grid-cols-2 gap-y-3 gap-x-6" data-id="element-167">
                        {mod.items.map((item, itemIdx) => <li key={itemIdx} className="flex items-start gap-2 text-zinc-300 text-sm md:text-base" data-id="element-168">
                            <div className="w-1.5 h-1.5 rounded-full bg-lime-500 mt-2 shrink-0" data-id="element-169"></div>
                            <span data-id="element-170">{item}</span>
                          </li>)}
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};